<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span class="text-danger" style="display:flex;align-items:center;gap:6px">
    <mat-icon class="me-2">warning</mat-icon>
    Confirmar eliminación
  </span>
  <button mat-icon-button [mat-dialog-close]="false" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
    <p class="mb-3">
        ¿Está seguro de que desea eliminar la siguiente baja?
    </p>

    <div class="alert alert-warning">
        <div class="row">
            <div class="col-md-4"><strong>Empleado:</strong></div>
            <div class="col-md-8">{{ data.empleadoNombre }}</div>
        </div>
        <div class="row">
            <div class="col-md-4"><strong>Fecha de inicio:</strong></div>
            <div class="col-md-8">{{ data.fechaInicio }}</div>
        </div>
        <div class="row">
            <div class="col-md-4"><strong>Motivo:</strong></div>
            <div class="col-md-8">{{ data.motivo }}</div>
        </div>
    </div>

    <p class="text-danger">
        <strong>Esta acción no se puede deshacer.</strong>
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="me-2">
        Cancelar
    </button>
    <button mat-raised-button color="warn" (click)="confirmar()">
        <mat-icon>delete</mat-icon>
        Eliminar
    </button>
</mat-dialog-actions>
